import {
  RQ_FILTER_AGGREGATES_KEY,
  RQ_FILTER_AGGREGATES_SHOP_KEY,
  RQ_PRODUCT_SEARCH_KEY,
} from '../ReactQuery/cacheKeys';
import { normaliseCompositeSizeIds } from '../filters/helpers';

import { type SearchFilters } from './useSearchFilters';

export function buildProductSearchQueryKey({
  location,
  searchInput = '',
  searchFilters,
}: {
  location?: string;
  searchInput?: string;
  searchFilters: SearchFilters;
}) {
  return [
    RQ_PRODUCT_SEARCH_KEY,
    {
      location,
      searchInput,
      searchFilters: {
        ...searchFilters,
        sizes: searchFilters.sizes?.length
          ? normaliseCompositeSizeIds(searchFilters.sizes)
          : undefined,
      },
    },
  ];
}

export function buildFilterAggregatesQueryKey({
  location,
  searchInput = '',
  searchFilters,
  sellerId,
}: {
  location?: string;
  searchInput?: string;
  searchFilters: SearchFilters;
  sellerId?: number;
}) {
  const { sizes, ...searchFiltersWithoutSizes } = searchFilters;

  return sellerId
    ? [
        RQ_FILTER_AGGREGATES_SHOP_KEY,
        {
          location,
          searchFilters: searchFiltersWithoutSizes,
          sellerId,
          searchInput,
        },
      ]
    : [
        RQ_FILTER_AGGREGATES_KEY,
        { location, searchFilters: searchFiltersWithoutSizes, searchInput },
      ];
}
